export default "__VITE_ASSET__76ac6147__"